import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { useDispatch } from 'react-redux';
import { actions as pharmacyListActions } from '../../../redux/appointmentForm/requests/pharmacy-req';

import TextInput from '../../TextInput';
import Button from '../../Button';
import PharmacyPopup from '../../AppointmentForm/AppointmentPharmacy/PharmacyPopup';

import styles from './styles.styl';
import { makePharmacyTitle } from '../../../utils/makePharmacyTitle';

const PreferredPharmacy = ({
  value,
  placeholder,
  label,
  onChange,
  onHandleBlur,
  limit,
  intl: { formatMessage },
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [pharmacy, setPharmacy] = useState(value);
  const dispatch = useDispatch();

  const togglePopupHandle = () => {
    setIsOpen(current => !current);
    dispatch(pharmacyListActions.clear());
  };

  const handlePharmacy = incomePharmacy => {
    if (incomePharmacy) {
      onChange(incomePharmacy);
      setPharmacy(makePharmacyTitle(incomePharmacy, true));
    }
  };

  return (
    <React.Fragment>
      <div className={styles.wrapper}>
        <TextInput
          autoresize
          value={pharmacy}
          placeholder={placeholder}
          label={label}
          type="text"
          textarea
          onChange={onChange}
          onBlur={onHandleBlur}
          limit={limit}
          className={styles.textarea}
          disabled
        />
        <Button
          raised
          color="accent"
          className={styles.button}
          onClick={togglePopupHandle}
        >
          {formatMessage({ id: 'appointments.form.changePharmacy' })}
        </Button>
      </div>
      {isOpen && (
        <PharmacyPopup
          isOpen={isOpen}
          onClose={togglePopupHandle}
          setPharmacy={handlePharmacy}
        />
      )}
    </React.Fragment>
  );
};

PreferredPharmacy.propTypes = {
  onHandleBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  limit: PropTypes.number,
  intl: PropTypes.object,
};

export default injectIntl(PreferredPharmacy);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/PreferredPharmacy/index.jsx